import { logger } from '../../utils/logger';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { getV2AuthHeaders } from '../../utils/authHeaders';
import { getEnv } from '../../config/env';

interface DeleteMigrationResponse {
  success: boolean;
  message?: string;
}

export const deleteMigration = async (
  bearerToken: string,
  migrationId: string
): Promise<DeleteMigrationResponse> => {
  try {
    const baseUrl = getEnv().VITE_EDCI_API_URL;
    const url = `${baseUrl}/api/migrations/delete/${migrationId}`;

    const response = await authenticatedFetch(url, {
      method: 'DELETE',
      headers: getV2AuthHeaders(bearerToken)
    });

    if (!response.ok) {
      logger.error('Delete migration API returned error', {
        status: response.status,
        statusText: response.statusText,
        migrationId,
        url
      });
      throw new Error(`Failed to delete migration: ${response.status} ${response.statusText}`);
    }

    // Check if response has content
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const result = await response.json();
      logger.info('Migration deleted successfully', { migrationId });
      return result;
    }

    // If no content, return success
    logger.info('Migration deleted successfully', { migrationId });
    return { success: true };
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    logger.error('Failed to delete migration', {
      error: msg,
      migrationId,
      url: `${getEnv().VITE_EDCI_API_URL}/api/migrations/delete/${migrationId}`
    });
    throw error;
  }
};
